import styled from 'styled-components'
import { RiSideBarFill, RiSideBarLine } from 'react-icons/ri'
import useSidebar from '../../hooks/useSidebar'
import { useSnapshot } from 'valtio'
import { media } from '../../styles/media'

// The back button's size and weight, but a window with its sidebar rather
// than an arrow, so the two never read alike when both are in the header.
// The panel is filled while the sidebar is open, outlined while it is folded.
const IconButton = styled.button`
  background-color: transparent;
  color: ${({ theme }) => theme.font.color};
  border: none;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: center;
  cursor: pointer;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;

  svg {
    width: 1.75rem;
    height: 1.75rem;
  }

  &:hover {
    opacity: 80%;
  }

  ${media.phone} {
    width: 44px;
    height: 44px;
  }
`

function HeaderSidebarToggle() {
  const { toggleSidebar, sbState } = useSidebar()
  const snap = useSnapshot(sbState)

  const handleToggle = (e) => {
    e.nativeEvent.stopPropagation()
    toggleSidebar()
  }

  return (
    <IconButton
      data-testid='sidebar.toggle'
      id='navCollapseButton'
      onClick={handleToggle}
    >
      {snap.visible ? <RiSideBarFill /> : <RiSideBarLine />}
    </IconButton>
  )
}

export default HeaderSidebarToggle
